import { render, staticRenderFns } from "./ingredientsConfig.vue?vue&type=template&id=61ba9de6&scoped=true"
import script from "./ingredientsConfig.vue?vue&type=script&lang=js"
export * from "./ingredientsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba9de6",
  null
  
)

export default component.exports